import { Component, OnDestroy, OnInit } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

//helpers
import { OrderHelper } from '../shared/helpers';

//services
import { OrderService } from '../shared/services';

//enums
import { ValidationStatusEnum } from '../shared/enums';
enum RestrictionStateEnum {
  open,
  passed,
  failed
}

//interfaces
import { OrderItemInterface, OrderPreviewItemInterface } from '../shared/interfaces';


@Component({
  selector: 'app-control',
  templateUrl: './control.component.html',
  styleUrl: './control.component.scss'
})
export class ControlComponent implements OnInit, OnDestroy {
  public restriction: number | null = null;
  public order: boolean = false;
  public removedItems: OrderPreviewItemInterface[] = [];
  public restrictionState: RestrictionStateEnum = RestrictionStateEnum.open;
  public restrictionStateEnum = RestrictionStateEnum;

  private $interval: any;



  constructor(
    private orderHelper: OrderHelper,
    private orderService: OrderService

  ) { }

  async ngOnInit() {
      this.order = true;
      this.checkForRestriction();
  }

  private async checkForRestriction() {
    const items = OrderService.orderPreview.value.order?.itemList;
    items?.forEach(element => {
      if (element.article.minimum_age && (!this.restriction || element.article.minimum_age > this.restriction)) {
        this.restriction = element.article.minimum_age;
      }
    });
    if (this.restriction) {
      await lastValueFrom(this.orderService.resetRestrictionStatus());
      this.$interval = setInterval(async () => {
        try {
          document.dispatchEvent(new MouseEvent('click'));
          const res = await lastValueFrom(this.orderService.getRestrictionStatus());
          if (res.device.state !== ValidationStatusEnum.awaiting) {
            clearInterval(this.$interval);
            switch (res.device.state) {
              case ValidationStatusEnum.notValidated:
                this.removeItems(16);
                break;
              case ValidationStatusEnum.over16:
                this.removeItems(18);
                break;
              case ValidationStatusEnum.over18:
                this.restrictionState = RestrictionStateEnum.passed;
                break;

              default:
                break;
            }
            await lastValueFrom(this.orderService.resetRestrictionStatus());
          }
        } catch (error) {

        }
      }, 3000);
    }

  }
  private removeItems(minimum_age: number) {
   let orderPreview = OrderService.orderPreview.value!;
   let order = OrderService.order.value!;
   orderPreview.order!.itemList.forEach((element, index) => {
      if (element.article.minimum_age && (element.article.minimum_age >= minimum_age)) {
        order.itemList.splice(index, 1);
        orderPreview.order!.itemList.splice(index, 1);
        this.removedItems.push(element);
      }

    });
    if (this.removedItems.length) {
      this.restrictionState = RestrictionStateEnum.failed;
      if (orderPreview.order!.itemList.length)
        this.orderHelper.recalculateOrder();
    } else {
      this.restrictionState = RestrictionStateEnum.passed;
    } 
  }

  ngOnDestroy(): void {
    if (this.$interval) clearInterval(this.$interval);
  }
}
